import React from 'react'
import { Accordion, FontIcon, Modal, tokens } from '@arvoreeducacao/bonsai-ds'
import { useTranslation } from 'i18n'
import {
  AccordionContent,
  AccordionText,
  AccordionWrapper,
  MapGoalInformationWrapper,
  MapGoalText,
  MapGoalTitle,
  ReadingDataGraphImage,
  Subtitle
} from './ReadingDataInfo.style'
import type { ReadingDataInfoProps } from './ReadingDataInfo.types'
import { READING_DATA_INFO_ITEMS } from './constants'

const ReadingDataInfo: React.FC<ReadingDataInfoProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      portalContainer={document.getElementById('modal')}
      isOpen={isOpen}
      onClose={onClose}
      type={'standard'}
      center
      hasDesktopCloseButton
      title={t('Como funciona o Mapa de Leitura de Livros?')}
      titleSize={3}
      size={'medium'}
    >
      <Subtitle>
        {t(
          'Nosso sistema analisa a velocidade de leitura e a quantidade de texto em cada página, comparando com as velocidades esperadas para a faixa etária para identificar uma “leitura válida”.'
        )}
      </Subtitle>
      <ReadingDataGraphImage />
      <Accordion
        data={{
          id: 'accordion',
          template: [
            <AccordionWrapper key={1}>
              <FontIcon
                iconName="information"
                color={tokens.colors.dark4}
                size={20}
              />
              <AccordionText>
                {t('Como interpretar esses dados?')}
              </AccordionText>
            </AccordionWrapper>
          ],
          iconRight: true,
          children: [
            {
              id: 'accordion-children',
              template: [
                <AccordionContent key={'accordion-content'}>
                  {READING_DATA_INFO_ITEMS.map(infoItem => {
                    return (
                      <MapGoalInformationWrapper
                        key={infoItem.id}
                        color={infoItem.backgroundColor}
                      >
                        <MapGoalTitle color={infoItem.textColor}>
                          {infoItem.title}
                        </MapGoalTitle>
                        <MapGoalText>{infoItem.text}</MapGoalText>
                      </MapGoalInformationWrapper>
                    )
                  })}
                </AccordionContent>
              ]
            }
          ]
        }}
      />
    </Modal>
  )
}

export default ReadingDataInfo
